export default function StickyCtaBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#c8a96e] py-3 px-4 shadow-lg">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-4">
        <p className="text-black text-xs sm:text-sm font-bold tracking-wide hidden sm:block">
          Ready to build real strength after 60?
        </p>
        <a
          href="https://masonhalefit.com"
          className="w-full sm:w-auto text-center bg-black text-[#c8a96e] text-xs sm:text-sm font-black tracking-[0.15em] uppercase px-6 py-2.5 rounded-sm hover:bg-[#1a1a1a] transition-all cursor-pointer whitespace-nowrap"
          aria-label="Get The Over-60 Strength Blueprint for $19.99"
        >
          Get The Over-60 Strength Blueprint — $19.99
        </a>
      </div>
    </div>
  );
}
